import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
    FiChevronRight,
    FiArrowLeft,
    FiFileText,
    FiWind,
    FiShield
} from 'react-icons/fi'

import vic2 from '../../../Assets/claimpro-design-home/recovery-van.png'
import vic3 from '../../../Assets/claimpro-design-home/crane.png'
import mechanic from '../../../Assets/claimpro-design-home/mechanic-home.png'
import inspection from '../../../Assets/claimpro-design-home/vehicle-inspection.png'
import workshop from '../../../Assets/claimpro-design-home/workshop.png'
import legal from '../../../Assets/claimpro-design-home/legal.png'
import pucc from '../../../Assets/claimpro-design-home/PUCC.png'
import insurance from '../../../Assets/claimpro-design-home/insurance.png'
import challan from '../../../Assets/claimpro-design-home/challan.png'

import CurrentOrdersList from '../VendorResponsesCustomer/CurrentOrdersList'
import BottomNavigationCustomer from './BottomNavigatonCustomer'
import './AllServices.css'

function AllServices() {
    const navigate = useNavigate()

    const goToNewService = () => {
        navigate('/add-new-vehicle-driver')
        localStorage.removeItem('formData')
    }

    useEffect(() => {
        const scrollToTop = () => {
            window.scrollTo(0, 0)
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0
        }
        scrollToTop()
        const timeoutId = setTimeout(scrollToTop, 100)
        return () => clearTimeout(timeoutId)
    }, [])

    const services = [
        {
            title: 'Recovery Van',
            tagline: 'Stuck? We Move You Forward',
            img: vic2,
            badge: '24/7',
            onClick: goToNewService,
        },
        {
            title: 'Crane Service',
            tagline: 'Powerful Lifting. Nationwide Reach',
            img: vic3,
            badge: '24/7',
            onClick: goToNewService,
        },
        {
            title: 'Vehicle Inspection',
            tagline: 'A Full Health Check, On The Spot',
            img: inspection,
            badge: '24/7',
            onClick: () => navigate('/general-inspection'),
        },
        {
            title: 'Workshop',
            tagline: 'Expert Hands for Heavy Wheels',
            img: workshop,
            badge: '24/7',
            onClick: () => navigate('/customer/workshop-dashboard'),
        },
        {
            title: 'Challan Assistance',
            tagline: 'Clear Your Pending Challans, Hassle-Free',
            img: challan,
            badge: 'New',
            onClick: () => navigate('/get-help'),
        },
        {
            title: 'PUCC Renewal',
            tagline: 'Emission Certificate, Delivered to You',
            img : pucc,
            badge: 'New',
            onClick: () => navigate('/get-help'),
        },
        {
            title: 'Insurance Renewal',
            tagline: 'Stay Covered. Never Miss a Due Date',
            img: insurance,
            badge: 'New',
            onClick: () => navigate('/get-help'),
        },
        {
            title: 'Advocate',
            tagline: 'Fast Legal Help. Fewer Roadblocks',
            img: legal,
            badge: 'Soon',
            disabled: true,
        },
        {
            title: 'Mechanic',
            tagline: 'Mechanics on the Move',
            img: mechanic,
            badge: 'Soon',
            disabled: true,
        },
    ]

    return (
        <div className="font-satoshi cp-allservices">

            {/* ============ HEADER ============ */}
            <header className="cp-header cp-header--sub">
                <button
                    type="button"
                    className="cp-back-btn"
                    aria-label="Go back"
                    onClick={() => navigate(-1)}
                >
                    <FiArrowLeft />
                </button>
                <div className="cp-header-logo">
                    <img src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/logo-compressed.png" alt="ClaimPro" />
                </div>
            </header>

            {/* ============ PAGE HERO ============ */}
            <section className="cp-page-hero">
                <p className="cp-page-hero-eyebrow">Everything You Need</p>
                <h1 className="cp-page-hero-title">All Services</h1>
                <p className="cp-page-hero-sub">
                    Roadside recovery, paperwork, and renewals — all in one place.
                </p>
            </section>

            {/* ============ SERVICES GRID ============ */}
            <div className="service-heading">
                <p>Browse Services</p>
            </div>

            <div className="cp-services-grid cp-services-grid--full">
                {services.map((s) => (
                    <div
                        key={s.title}
                        className={`cp-service-card ${s.disabled ? 'is-disabled' : ''}`}
                        onClick={s.disabled ? undefined : s.onClick}
                    >
                        <div className="cp-service-stage">
                            <span className={`cp-service-badge ${s.badge === 'Soon' ? 'soon' : ''} ${s.badge === 'New' ? 'new' : ''}`}>
                                {s.badge}
                            </span>
                            {s.img ? (
                                <img src={s.img} alt={s.title} />
                            ) : (
                                <span className="cp-service-icon">{s.icon}</span>
                            )}
                        </div>
                        <div className="cp-service-body">
                            <h4>{s.title}</h4>
                            <div className="cp-service-cta">
                                {s.disabled ? 'Coming Soon' : 'Book Now'} <FiChevronRight size={11} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <CurrentOrdersList />

            <BottomNavigationCustomer />
        </div>
    )
}

export default AllServices